// extracted by mini-css-extract-plugin
export default {"wrapper":"moreTags_wrapper__Qz4iY","top":"moreTags_top__TgtGp","tags":"moreTags_tags__TlaIv","bottom":"moreTags_bottom__CLCx0","button":"moreTags_button__HQmzi"};